import {useQuery} from "@sveltestack/svelte-query"
import {derived} from "svelte/store"

export function useUsers() {
  const queryResult = useQuery(`/api/users`)
  return derived(queryResult, values => {
    return values.data?.users ?? []
  })
}
